import {
  ActionCreatorWithoutNamespace,
  action$,
  ofType,
  extractPayload,
  withNamespace,
} from '@ardoq/rxbeach';
import { identity } from 'lodash';
import { useEffect } from 'react';
import { tap } from 'rxjs';

export const useOnOptionsChangedSubscription = <T = any,>(
  onOptionsChanged: (value: T) => void,
  optionsChangedAction: ActionCreatorWithoutNamespace<T>,
  namespace?: string
) => {
  useEffect(() => {
    const routine = action$.pipe(
      namespace ? withNamespace(namespace) : identity,
      ofType(optionsChangedAction),
      extractPayload(),
      tap(onOptionsChanged)
    );
    const subscription = routine.subscribe();
    return () => subscription.unsubscribe();
  }, [onOptionsChanged, namespace, optionsChangedAction]);
};
